export default __webpack_public_path__ + "static/general-fabrics-header-image-c1a6be7b398b2f83c8d8fc715a562e97.jpg";